import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export default function VideoModal({ open, onClose }) {
  const wedding = useContent();
  const youtubeId = wedding.media.saveTheDateYouTubeId;
  const params = new URLSearchParams({ autoplay: "1", rel: "0", modestbranding: "1", playsinline: "1", iv_load_policy: "3", color: "white" });
  const src = youtubeId ? `https://www.youtube.com/embed/${youtubeId}?${params.toString()}` : "";

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[100] bg-ink/95 backdrop-blur-md flex items-center justify-center p-4 sm:p-10"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          data-testid="video-modal"
        >
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-white/70 hover:text-white transition-colors"
            aria-label="Cerrar"
            data-testid="video-modal-close"
          >
            <X size={28} strokeWidth={1} />
          </button>

          <div className="absolute top-8 left-8">
            <span className="overline text-white/50">Save the Date</span>
          </div>

          <motion.div
            className="w-full max-w-5xl"
            initial={{ scale: 0.94, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.96, opacity: 0 }}
            transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative w-full aspect-video bg-black overflow-hidden">
              {src ? (
                <iframe
                  src={src}
                  title="Save the Date — Carolina & Roberto"
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
                  allowFullScreen
                  data-testid="save-the-date-video"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center text-center px-6">
                  <p className="font-display italic text-white/70 text-2xl">
                    El video estará disponible muy pronto.
                  </p>
                </div>
              )}
            </div>
            <p className="font-display italic text-white/80 text-center mt-6 text-xl">
              {wedding.bride} &amp; {wedding.groom} — {wedding.dateShort}
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
